import { SEGMENTS } from '@/components/OnboardingHandlerComponents/AiBuilderCreateSite/AiBuilderCreateSite.enum';

export const SEGMENTS_OPTIONS_LIST_BR = [
  { value: SEGMENTS.ACCOUNTING, label: 'Contabilidade' },
  { value: SEGMENTS.BOOKKEEPING, label: 'Escrituração' },
  { value: SEGMENTS.FINANCIAL_CONSULTING, label: 'Consultoria Financeira' },
  { value: SEGMENTS.ACUPUNCTURE, label: 'Acupuntura' },
  { value: SEGMENTS.CHIROPRACTOR, label: 'Quiropraxia' },
  { value: SEGMENTS.DENTIST, label: 'Dentista' },
  { value: SEGMENTS.DOCTOR, label: 'Médico' },
  { value: SEGMENTS.MASSAGE_THERAPY, label: 'Terapia de Massagem' },
  { value: SEGMENTS.PHYSIOTHERAPY, label: 'Fisioterapia' },
  { value: SEGMENTS.PSYCHOLOGY, label: 'Psicologia' },
  { value: SEGMENTS.WELLNESS, label: 'Bem-estar' },
  { value: SEGMENTS.YOGA_INSTRUCTION, label: 'Aulas de Yoga' },
  { value: SEGMENTS.BARBER_SHOP, label: 'Barbearia' },
  { value: SEGMENTS.BEAUTY, label: 'Beleza' },
  { value: SEGMENTS.HAIR_STYLIST, label: 'Cabeleireiro' },
  { value: SEGMENTS.MAKEUP_ARTIST, label: 'Maquiador' },
  { value: SEGMENTS.BAKERY, label: 'Padaria' },
  { value: SEGMENTS.CAFE, label: 'Café' },
  { value: SEGMENTS.CATERING, label: 'Serviço de Buffet' },
  { value: SEGMENTS.CHEF, label: 'Chef' },
  { value: SEGMENTS.COFFEE_SHOP, label: 'Cafeteria' },
  { value: SEGMENTS.FAST_FOOD, label: 'Comida Rápida' },
  { value: SEGMENTS.PIZZA_RESTAURANT, label: 'Pizzaria' },
  { value: SEGMENTS.RESTAURANT, label: 'Restaurante' },
  { value: SEGMENTS.BUSINESS_CONSULTING, label: 'Consultoria Empresarial' },
  { value: SEGMENTS.CAREER_COACHING, label: 'Coaching de Carreira' },
  { value: SEGMENTS.COACHING, label: 'Coaching' },
  { value: SEGMENTS.CONSULTING, label: 'Consultoria' },
  { value: SEGMENTS.COUNSELLING, label: 'Aconselhamento' },
  { value: SEGMENTS.EDUCATION, label: 'Educação' },
  { value: SEGMENTS.IT_CONSULTING, label: 'Consultoria de TI' },
  { value: SEGMENTS.LAW_FIRM, label: 'Escritório de Advocacia' },
  { value: SEGMENTS.PROJECT_MANAGEMENT, label: 'Gestão de Projetos' },
  { value: SEGMENTS.PUBLIC_RELATIONS, label: 'Relações Públicas' },
  { value: SEGMENTS.RESUME_WRITING, label: 'Criação de Currículo' },
  { value: SEGMENTS.SOCIAL_MEDIA_MARKETING, label: 'Marketing em Mídias Sociais' },
  { value: SEGMENTS.TRANSLATION, label: 'Tradução' },
  { value: SEGMENTS.AUDIO_EDITING, label: 'Edição de Áudio' },
  { value: SEGMENTS.AUDIO_PRODUCTION, label: 'Produção de Áudio' },
  { value: SEGMENTS.CONTENT_WRITING, label: 'Redação de Conteúdo' },
  { value: SEGMENTS.COPYWRITING, label: 'Copywriting' },
  { value: SEGMENTS.DESIGN, label: 'Design' },
  { value: SEGMENTS.DEVELOPMENT_AND_DESIGN, label: 'Desenvolvimento e Design' },
  { value: SEGMENTS.DIGITAL_MARKETING, label: 'Marketing Digital' },
  { value: SEGMENTS.GRAPHIC_DESIGN, label: 'Design Gráfico' },
  { value: SEGMENTS.ILLUSTRATING, label: 'Ilustração' },
  { value: SEGMENTS.MARKETING, label: 'Marketing' },
  { value: SEGMENTS.PHOTOGRAPHY, label: 'Fotografia' },
  { value: SEGMENTS.VIDEO_EDITING, label: 'Edição de Vídeo' },
  { value: SEGMENTS.VIDEO_PRODUCTION, label: 'Produção de Vídeo' },
  { value: SEGMENTS.WRITING, label: 'Escrita' },
  { value: SEGMENTS.PROPERTY_MANAGEMENT, label: 'Administração de Imóveis' },
  { value: SEGMENTS.REAL_ESTATE, label: 'Imobiliária' },
  { value: SEGMENTS.REAL_ESTATE_AGENCY, label: 'Agência Imobiliária' },
  { value: SEGMENTS.COMPUTER_REPAIR, label: 'Reparo de Computadores' },
  { value: SEGMENTS.MOBILE_REPAIR, label: 'Reparo de Celulares' },
  { value: SEGMENTS.SOFTWARE_DEVELOPMENT, label: 'Desenvolvimento de Software' },
  { value: SEGMENTS.UI_UX_DESIGN, label: 'Design UI/UX' },
  { value: SEGMENTS.WEB_DESIGN, label: 'Design de Sites' },
  { value: SEGMENTS.WEB_DEVELOPMENT, label: 'Desenvolvimento Web' },
  { value: SEGMENTS.CAR_DETAILING, label: 'Estética Automotiva' },
  { value: SEGMENTS.CAR_RENTALS, label: 'Aluguel de Carros' },
  { value: SEGMENTS.ELECTRIC_VEHICLES, label: 'Veículos Elétricos' },
  { value: SEGMENTS.EV_RENTALS, label: 'Aluguel de Veículos Elétricos' },
  { value: SEGMENTS.MECHANIC, label: 'Mecânico' },
  { value: SEGMENTS.TAXI, label: 'Táxi' },
  { value: SEGMENTS.TRUCKING, label: 'Transporte Rodoviário' },
  { value: SEGMENTS.CLEANING, label: 'Limpeza' },
  { value: SEGMENTS.CARPET_CLEANING, label: 'Limpeza de Carpetes' },
  { value: SEGMENTS.ELECTRICIAN, label: 'Eletricista' },
  { value: SEGMENTS.GARDENING, label: 'Jardinagem' },
  { value: SEGMENTS.HANDYMAN, label: 'Marido de Aluguel' },
  { value: SEGMENTS.HOUSE_CLEANING, label: 'Limpeza Residencial' },
  { value: SEGMENTS.LANDSCAPING, label: 'Paisagismo' },
  { value: SEGMENTS.LAWN_CARE, label: 'Cuidado com Gramado' },
  { value: SEGMENTS.PAINTING, label: 'Pintura' },
  { value: SEGMENTS.PLUMBING, label: 'Encanamento' },
  { value: SEGMENTS.POOL_CLEANING, label: 'Limpeza de Piscina' },
  { value: SEGMENTS.PRESSURE_WASHING, label: 'Lavagem a Pressão' },
  { value: SEGMENTS.DOG_TRAINING, label: 'Adestramento de Cães' },
  { value: SEGMENTS.DOG_WALKING, label: 'Passeio com Cães' },
  { value: SEGMENTS.PET_SITTING, label: 'Cuidados com Animais' },
  { value: SEGMENTS.FITNESS, label: 'Fitness' },
  { value: SEGMENTS.PERSONAL_TRAINING, label: 'Treinamento Pessoal' },
  { value: SEGMENTS.SPORTS_INSTRUCTION, label: 'Instrução Esportiva' },
  { value: SEGMENTS.DJ, label: 'DJ' },
  { value: SEGMENTS.EVENT_PLANNING, label: 'Planejamento de Eventos' },
  { value: SEGMENTS.ONLINE_ENTERTAINMENT, label: 'Entretenimento Online' },
  { value: SEGMENTS.ONLINE_STORE, label: 'Loja Virtual' },
  { value: SEGMENTS.RETAIL_STORE, label: 'Loja Física' },
  { value: SEGMENTS.SOLAR_INSTALLATION, label: 'Instalação Solar' },
  { value: SEGMENTS.BIKE_MECHANIC, label: 'Mecânico de Bicicletas' },
  { value: SEGMENTS.BOAT_DETAILING, label: 'Estética Náutica' },
  { value: SEGMENTS.CONSTRUCTION, label: 'Construção' },
  { value: SEGMENTS.FOOD_DELIVERY, label: 'Entrega de Comida' },
  { value: SEGMENTS.INFLUENCE_MARKETING, label: 'Marketing de Influência' },
  { value: SEGMENTS.INSURANCE_BROKER, label: 'Corretor de Seguros' },
  { value: SEGMENTS.INTERIOR_DESIGN, label: 'Design de Interiores' },
  { value: SEGMENTS.LOCKSMITH, label: 'Chaveiro' },
  { value: SEGMENTS.MUSIC_INSTRUCTION, label: 'Aulas de Música' },
  { value: SEGMENTS.ONLINE_LEARNING, label: 'Aprendizado Online' },
  { value: SEGMENTS.PEST_CONTROL, label: 'Controle de Pragas' },
  { value: SEGMENTS.SECURITY, label: 'Segurança' },
  { value: SEGMENTS.TRAVEL_AGENCY, label: 'Agência de Viagens' },
  { value: SEGMENTS.YOUTUBER, label: 'YouTuber' },
];
